@if (request(); as active) {
<div
  class="confirm-dialog fixed inset-0 z-[110] flex items-center justify-center overflow-y-auto bg-black/40 p-3 sm:p-4"
  role="alertdialog"
  aria-modal="true"
  [attr.aria-labelledby]="'confirm-dialog-title'"
  [attr.aria-describedby]="'confirm-dialog-message'"
  (click)="onBackdropClick($event)"
>
  <article
    class="confirm-dialog__panel flex w-full max-w-md flex-col overflow-hidden rounded-2xl border border-gray-200/70 bg-white shadow-[0_8px_30px_rgba(15,23,42,0.12)]"
    (click)="$event.stopPropagation()"
  >
    <header class="flex items-start gap-3 border-b border-gray-100 px-5 pb-3 pt-4">
      <span
        class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
        [class.bg-red-50]="active.options.variant === 'danger'"
        [class.text-red-600]="active.options.variant === 'danger'"
        [class.bg-[#f0f9fa]]="active.options.variant !== 'danger'"
        [class.text-[#0d6e7a]]="active.options.variant !== 'danger'"
      >
        <ion-icon
          [name]="active.options.variant === 'danger' ? 'warning-outline' : 'help-circle-outline'"
          class="text-xl"
          aria-hidden="true"
        ></ion-icon>
      </span>

      <div class="min-w-0 flex-1">
        <h2
          id="confirm-dialog-title"
          class="font-['Playfair_Display',serif] text-xl font-medium leading-tight text-[#1a2e26]"
        >
          {{ active.options.title }}
        </h2>
        <p id="confirm-dialog-message" class="mt-1.5 text-sm leading-relaxed text-gray-600">
          {{ active.options.message }}
        </p>
      </div>
    </header>

    <footer class="flex flex-col-reverse gap-2 px-5 py-4 sm:flex-row sm:justify-end">
      <button
        type="button"
        class="m-0 inline-flex min-h-10 appearance-none items-center justify-center rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-300/40"
        (click)="cancel()"
      >
        {{ active.options.cancelText }}
      </button>
      <button
        type="button"
        class="m-0 inline-flex min-h-10 appearance-none items-center justify-center rounded-lg px-4 py-2 text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2"
        [class]="confirmButtonClass(active.options.variant)"
        (click)="onConfirm()"
      >
        {{ active.options.confirmText }}
      </button>
    </footer>
  </article>
</div>
}
